import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Launch, LaunchesSliceState } from '../../types';

export const initialState: LaunchesSliceState = {
  launches: null,
};

const launchesSlice = createSlice({
  name: 'homeProductLaunches',
  initialState,
  reducers: {
    setLaunches(state, { payload }: PayloadAction<Launch[] | null>) {
      state.launches = payload;
    },
  },
});

export const { setLaunches } = launchesSlice.actions;

export default launchesSlice.reducer;
